module.exports = __webpack_public_path__ + "img/애고미_이모티콘-18.dc0ce60.png";